/**
 * @generated SignedSource<<3852e04f9dbe4f4a00c82e4dc715eb7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CurrentAndPastStakingsQuery$variables = Record<PropertyKey, never>;
export type CurrentAndPastStakingsQuery$data = {
  readonly currentAndPastStakings: {
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly portfolio?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly assets: {
                readonly edges: ReadonlyArray<{
                  readonly fiatTotalStakedAmount: PrecisionFloat | null | undefined;
                  readonly stakedBalance: ValueChange | null | undefined;
                } | null | undefined> | null | undefined;
                readonly totalCount: number | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly staking?: {
          readonly yearlyInterest: number | null | undefined;
        } | null | undefined;
        readonly symbol: string | null | undefined;
      };
      readonly rewardsFiat: PrecisionFloat;
      readonly stakedAsset: PrecisionFloat;
      readonly stakedFiat: PrecisionFloat;
    }> | null | undefined;
    readonly totalRewardsFiat: PrecisionFloat | null | undefined;
    readonly totalStakedFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type CurrentAndPastStakingsQuery = {
  response: CurrentAndPastStakingsQuery$data;
  variables: CurrentAndPastStakingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRewardsFiat",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalStakedFiat",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedFiat",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedAsset",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsFiat",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetStaking",
      "kind": "LinkedField",
      "name": "staking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyInterest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetPortfoliosConnection",
      "kind": "LinkedField",
      "name": "portfolio",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AssetPortfoliosEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Portfolio",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioAssetsConnection",
                  "kind": "LinkedField",
                  "name": "assets",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PortfolioAssetsEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "stakedBalance",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fiatTotalStakedAmount",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CryptoAsset",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CurrentAndPastStakingsQuery",
    "selections": [
      {
        "alias": "currentAndPastStakings",
        "args": null,
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CurrentAndPastStakingsQuery",
    "selections": [
      {
        "alias": "currentAndPastStakings",
        "args": null,
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98140c0fa4898315ca7860986d285b1a",
    "id": null,
    "metadata": {},
    "name": "CurrentAndPastStakingsQuery",
    "operationKind": "query",
    "text": "query CurrentAndPastStakingsQuery {\n  currentAndPastStakings: stakingOverview {\n    totalRewardsFiat\n    totalStakedFiat\n    items {\n      stakedFiat\n      stakedAsset\n      rewardsFiat\n      asset {\n        __typename\n        id\n        name\n        logoUrl\n        symbol\n        ... on CryptoAsset {\n          staking {\n            yearlyInterest\n          }\n          portfolio {\n            edges {\n              node {\n                assets {\n                  totalCount\n                  edges {\n                    stakedBalance\n                    fiatTotalStakedAmount\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ede9ff9ef981ee36b522a6698f11efb6";

export default node;
